import { Injectable } from "@angular/core";
import { FiltersM } from "../../../models";
import { CommonAdapter, ConsolidadoAdapter, PeriodoAdapter, TreeAdapter } from "../Filtros";
import { FilterAdapter } from "../filter-adapter.interface";

@Injectable({
  providedIn: 'root'
})
export class FilterAdapterRegistry {
  private readonly adapters = 
    new Map<FiltersM, FilterAdapter<any> >([
      [FiltersM.SUCURSALES, new ConsolidadoAdapter()],
      [FiltersM.PERSPECTIVES, new CommonAdapter()],
      [FiltersM.INDICADORES, new ConsolidadoAdapter()],
      [FiltersM.MOUNTH, new CommonAdapter()],
      [FiltersM.YEAR, new CommonAdapter()],
      [FiltersM.ESCENARIOS, new ConsolidadoAdapter()],
      [FiltersM.BUSQUEDA, new ConsolidadoAdapter()],
      [FiltersM.PERIOD, new PeriodoAdapter()],
      [FiltersM.TREE, new TreeAdapter()],
      [FiltersM.COMMON, new CommonAdapter()],
      [FiltersM.CONSOLIDADO, new ConsolidadoAdapter()],
    ]);

  /**
   * Registrar un Adapter.
   */
  public register(
    type: FiltersM,
    adapter: FilterAdapter<any>
  ): void {
    this.adapters.set(type, adapter);
  }

  /**
   * Obtener el Adapter correspondiente.
   */
  public resolve(
    type: FiltersM
  ): FilterAdapter<any> {
    const adapter = this.adapters.get(type);
    if (!adapter) {
        throw new Error(
            `No existe un Adapter registrado para ${type}`
        );
    }
    return adapter;
  }
}